import React, { useState } from 'react';
import { AudioAnalysisFilters } from '../types';
import './FilterPanel.css';

interface FilterPanelProps {
  isOpen: boolean;
  filters: AudioAnalysisFilters;
  onFilterChange: (filters: AudioAnalysisFilters) => void;
  onClearFilters: () => void;
}

const FilterPanel: React.FC<FilterPanelProps> = ({
  isOpen,
  filters,
  onFilterChange,
  onClearFilters
}) => {
  const [localFilters, setLocalFilters] = useState<AudioAnalysisFilters>(filters);

  const handleInputChange = (key: keyof AudioAnalysisFilters, value: any) => {
    const newFilters = { ...localFilters, [key]: value };
    setLocalFilters(newFilters);
  };

  const handleApplyFilters = () => {
    onFilterChange(localFilters);
  };

  const handleClearFilters = () => {
    setLocalFilters({});
    onClearFilters();
  };

  if (!isOpen) return null;

  return (
    <div className="filter-panel">
      <div className="filter-panel-header">
        <h3>Filtros</h3>
      </div>
      
      <div className="filter-panel-content">
        <div className="filter-row">
          <div className="filter-group">
            <label>Rádio</label>
            <input
              type="text"
              value={localFilters.radio || ''}
              onChange={(e) => handleInputChange('radio', e.target.value)}
              placeholder="Nome da rádio"
            />
          </div>
          
          <div className="filter-group">
            <label>Sentimento</label>
            <select
              value={localFilters.sentiment_type || ''}
              onChange={(e) => handleInputChange('sentiment_type', e.target.value)}
            >
              <option value="">Todos</option>
              <option value="positivo">Positivo</option>
              <option value="negativo">Negativo</option>
              <option value="neutro">Neutro</option>
            </select>
          </div>
          
          <div className="filter-group">
            <label>Cliente</label>
            <input
              type="text"
              value={localFilters.client || ''}
              onChange={(e) => handleInputChange('client', e.target.value)}
              placeholder="Nome do cliente"
            />
          </div>
        </div>
        
        <div className="filter-row">
          <div className="filter-group">
            <label>Categoria</label>
            <select
              value={localFilters.categoria || ''}
              onChange={(e) => handleInputChange('categoria', e.target.value)}
            >
              <option value="">Todas</option>
              <option value="elogio">Elogio</option>
              <option value="reclamação">Reclamação</option>
              <option value="informação">Informação</option>
            </select>
          </div>
          
          <div className="filter-group">
            <label>Termo</label>
            <input
              type="text"
              value={localFilters.termo || ''}
              onChange={(e) => handleInputChange('termo', e.target.value)}
              placeholder="Termo de busca"
            />
          </div>
          
          <div className="filter-group">
            <label>Menção Prefeitura</label>
            <select
              value={localFilters.mentioned_prefecture === true ? 'true' : localFilters.mentioned_prefecture === false ? 'false' : ''}
              onChange={(e) => handleInputChange('mentioned_prefecture', e.target.value === 'true' ? true : e.target.value === 'false' ? false : undefined)}
            >
              <option value="">Todas</option>
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </select>
          </div>
        </div>
        
        <div className="filter-row">
          <div className="filter-group">
            <label>Data Início</label>
            <input
              type="date"
              value={localFilters.created_at_start || ''}
              onChange={(e) => handleInputChange('created_at_start', e.target.value)}
            />
          </div>
          
          <div className="filter-group">
            <label>Data Fim</label>
            <input
              type="date"
              value={localFilters.created_at_end || ''}
              onChange={(e) => handleInputChange('created_at_end', e.target.value)}
            />
          </div>
        </div>
      </div>
      
      <div className="filter-panel-actions">
        <button onClick={handleClearFilters} className="btn btn-secondary">
          Limpar Filtros
        </button>
        <button onClick={handleApplyFilters} className="btn btn-primary">
          Aplicar Filtros
        </button>
      </div>
    </div>
  );
};

export default FilterPanel;
